import './styles/main.css'
import { initRouter, addRoute, onNotFound } from './router.js'
import { renderHeader } from './components/header.js'
import { renderFooter } from './components/footer.js'
import { renderCartDrawer } from './components/cart-drawer.js'
import { renderHome } from './pages/home.js'
import { renderShop } from './pages/shop.js'
import { renderProduct } from './pages/product.js'
import { renderContact } from './pages/contact.js'
import { renderCheckout, renderSuccess } from './pages/checkout.js'
import { renderAdminLogin } from './pages/admin/login.js'
import { renderAdminProducts } from './pages/admin/products.js'
import { renderProductForm } from './pages/admin/product-form.js'
import { renderAdminCategories } from './pages/admin/categories.js'
import { renderAdminPromoCodes } from './pages/admin/promo-codes.js'
import { renderAdminUsers } from './pages/admin/users.js'
import { renderAdminBlog } from './pages/admin/blog.js'
import { renderBlogForm } from './pages/admin/blog-form.js'
import { store } from './store.js'
import { getProducts } from './lib/supabase.js'

// Expose store for inline event handlers (e.g. cart empty button)
window.__store = store

// Refresh any stale cart item images on every page load
if (store.get('cart').length) {
  getProducts().then(products => store.refreshCartImages(products)).catch(() => {})
}

// Mount persistent shell components
renderHeader(document.getElementById('header-outlet'))
renderCartDrawer(document.getElementById('cart-drawer-outlet'))
renderFooter(document.getElementById('footer-outlet'))

// Define routes
addRoute('/', renderHome)
addRoute('/shop', renderShop)
addRoute('/product/:id', renderProduct)
addRoute('/contact', renderContact)
addRoute('/checkout', renderCheckout)
addRoute('/success', renderSuccess)
addRoute('/admin/login', renderAdminLogin)
addRoute('/admin', renderAdminProducts)
addRoute('/admin/products/new', renderProductForm)
addRoute('/admin/products/:id/edit', renderProductForm)
addRoute('/admin/categories', renderAdminCategories)
addRoute('/admin/promo-codes', renderAdminPromoCodes)
addRoute('/admin/users', renderAdminUsers)
addRoute('/admin/blog', renderAdminBlog)
addRoute('/admin/blog/new', renderBlogForm)
addRoute('/admin/blog/:id/edit', renderBlogForm)

// 404 fallback
onNotFound((outlet) => {
  outlet.innerHTML = `
    <div class="section">
      <div class="container" style="text-align:center; max-width: 480px">
        <div class="section-eyebrow" style="margin-bottom: var(--space-4)">404</div>
        <h1 class="section-title" style="margin-bottom: var(--space-4)">Page not found</h1>
        <p class="text-secondary" style="margin-bottom: var(--space-8)">The page you're looking for doesn't exist.</p>
        <a href="#/" class="btn btn-primary btn-lg">Go Home</a>
      </div>
    </div>
  `
})

// Start router
initRouter(document.getElementById('page-outlet'))
